// src/components/organisms/SeriesForm.js
import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { US_RATINGS, TV_CATEGORIES } from "../../../../constants/constants";

const SeriesForm = ({ initialData = null, onSubmit, isEdit = false }) => {
  const [seriesTitle, setSeriesTitle] = useState(
    initialData ? initialData.seriesTitle : ""
  );
  const [description, setDescription] = useState(
    initialData ? initialData.description : ""
  );
  const [category, setCategory] = useState(
    initialData ? initialData.category : ""
  );
  const [contentRating, setContentRating] = useState(initialData ? initialData.contentRating : "");
  const [thumbnail, setThumbnail] = useState(
    initialData ? initialData.thumbnail : ""
  );

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      seriesTitle,
      description,
      category,
      contentRating,
      thumbnail,
    };

    try {
      if (isEdit) {
        if (onSubmit) {
          await onSubmit(formData);
        } else if (initialData && initialData.id) {
          const seriesDocRef = doc(db, "series", initialData.id);
          await updateDoc(seriesDocRef, {
            ...formData,
            updatedAt: serverTimestamp(),
          });
          alert("Series updated successfully");
        }
      } else {
        await addDoc(collection(db, "series"), {
          ...formData,
          createdAt: serverTimestamp(),
        });
        alert("Series created successfully");
        // Clear the form fields after creation
        setSeriesTitle("");
        setDescription("");
        setCategory("");
        setContentRating("");
        setThumbnail("");
      }
    } catch (error) {
      console.error("Error submitting series:", error);
    }
  };

  return (
    <Box component="form" onSubmit={handleFormSubmit} sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        {isEdit ? "Edit Series" : "Create New Series"}
      </Typography>
      <TextField
        label="Series Title"
        value={seriesTitle}
        onChange={(e) => setSeriesTitle(e.target.value)}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="category-label">Category</InputLabel>
        <Select
          labelId="category-label"
          label="Category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          {TV_CATEGORIES.map((cat) => (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="content-rating-label">Content Rating</InputLabel>
        <Select
          labelId="content-rating-label"
          label="Content Rating"
          value={contentRating}
          onChange={(e) => setContentRating(e.target.value)}
        >
          {US_RATINGS.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Thumbnail URL"
        value={thumbnail}
        onChange={(e) => setThumbnail(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button type="submit" variant="contained" color="primary">
        {isEdit ? "Update Series" : "Create Series"}
      </Button>
    </Box>
  );
};

export default SeriesForm;
